<template>
  <PageHeader
    title="Identity Access Management Console"
    subtitle="Manage users, roles, and permissions within the system"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  >
    <template #bottom>
      <Page_Tabs
        :tabs="tabs"
        class="px-6 pt-4"
        no-border
      />
    </template>
  </PageHeader>

  <div class="p-4">
    <!-- Manage Users -->
    <div v-if="activeTab === 'users'">
      <User_Access_Table />
    </div>

    <!-- Role Configurations -->
    <div v-else-if="activeTab === 'roles'">
      <Config_Roles />
    </div>

    <!-- Audit Logs -->
    <div v-else-if="activeTab === 'audit'">
      <User_Activity_Table />
    </div>
  </div>
</template>

<script>
import User_Access_Table from '@/components/Lists/User_Access_Table.vue';
import User_Activity_Table from '@/components/Lists/User_Activity_Table.vue';
import Config_Roles from '@/components/forms/Config_Roles.vue';
import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';
import { mapGetters } from 'vuex';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'IAMConsole',
  components: {
    User_Access_Table,
    User_Activity_Table,
    Config_Roles,
    PageHeader,
    Page_Tabs
  },
  computed: {
    ...mapGetters('auth', ['current_user']),
    ...mapGetters('tenant', ['isSecurityUser']),
    canConfigRoles() {
      return canAccessFeature(FEATURES.ACTION_ROLE_CONFIG);
    },
    canViewAuditLog() {
      return canAccessFeature(FEATURES.MODULE_ADMIN_AUDIT_LOG);
    },
    tabs() {
      const items = [
        {
          key: 'users',
          label: 'Manage Users',
          description: 'Create and manage user accounts, access roles, and entity assignments',
          to: '/tenantadmin/iam-console/users',
        },
      ];
      if (this.canConfigRoles) {
        items.push({
          key: 'roles',
          label: 'Role Configurations',
          description: 'Configure access roles and the permissions they grant',
          to: '/tenantadmin/iam-console/roles',
        });
      }
      if (this.canViewAuditLog) {
        items.push({
          key: 'audit',
          label: 'Audit Logs',
          description: 'Review user activity and administrative changes',
          to: '/tenantadmin/iam-console/audit',
        });
      }
      return items;
    },
    activeTab() {
      const routeTab = this.$route.meta.iamTab;
      return this.tabs.some((tab) => tab.key === routeTab) ? routeTab : 'users';
    },
  },
  watch: {
    $route: 'ensureAvailableTab',
  },
  created() {
    this.ensureAvailableTab();
  },
  methods: {
    ensureAvailableTab() {
      if (!this.tabs.some((tab) => tab.key === this.$route.meta.iamTab)) {
        this.$router.replace('/tenantadmin/iam-console/users').catch(() => {});
      }
    },
  },
};
</script>
